/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Admin } from './Admin';
import {
    AdminFromJSON,
    AdminFromJSONTyped,
    AdminToJSON,
} from './Admin';
import type { AppSettings } from './AppSettings';
import {
    AppSettingsFromJSON,
    AppSettingsFromJSONTyped,
    AppSettingsToJSON,
} from './AppSettings';

/**
 * 
 * @export
 * @interface AdminLoginPayload
 */
export interface AdminLoginPayload {
    /**
     * 
     * @type {boolean}
     * @memberof AdminLoginPayload
     */
    requires_2fa?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminLoginPayload
     */
    token?: string;
    /**
     * 
     * @type {Admin}
     * @memberof AdminLoginPayload
     */
    user?: Admin;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminLoginPayload
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {AppSettings}
     * @memberof AdminLoginPayload
     */
    settings?: AppSettings;
}

/**
 * Check if a given object implements the AdminLoginPayload interface.
 */
export function instanceOfAdminLoginPayload(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminLoginPayloadFromJSON(json: any): AdminLoginPayload {
    return AdminLoginPayloadFromJSONTyped(json, false);
}

export function AdminLoginPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminLoginPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requires_2fa': !exists(json, 'requires_2fa') ? undefined : json['requires_2fa'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'user': !exists(json, 'user') ? undefined : AdminFromJSON(json['user']),
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'settings': !exists(json, 'settings') ? undefined : AppSettingsFromJSON(json['settings']),
    };
}

export function AdminLoginPayloadToJSON(value?: AdminLoginPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requires_2fa': value.requires_2fa,
        'token': value.token,
        'user': AdminToJSON(value.user),
        'permissions': value.permissions,
        'settings': AppSettingsToJSON(value.settings),
    };
}

